import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Modal from 'react-modal';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { get } from '../../../server/actions';
import { _addNotification, allowNumericWithdecimal, _addNotificationError, gradeTextToNumber, numberOnly } from '../../../server/util';
import { BASE_URL_3, dial_code, ENV } from "../../../server/constants";
var converter = require('number-to-words');
const styles = {
    formInput: {
        marginTop: 10,
        marginBottom: 10,
        //width: 'auto'
    },
    buttonIcon: {
        cursor: "pointer",
        marginTop: 20,
        marginBottom: 20,
    }
}
const modalStyles = {
    content: {
        top: '35%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
class StudentRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            loading: false,
            event: {},
            parentEvent: {},
            id: 0,
            logoUrl: '',
            schoolName: '',
            mobileMaxLength: "10",
            schoolId: '',
            gradesMapping: [],
            respData: [],
            studentsArray: [{
                lastName: "",
                firstName: "",
                grade: "",
                studentId: ""
            }],
            parentDetails: [{
                emailId: "",
                altEmailId: "",
                mobile: "",

            }],
        }
    }
    componentWillMount = () => {
        const { schoolYear } = this.context.router.route.match.params
        this.setState({
            schoolYear: schoolYear
        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        let url = window.location.href;
        let subdomain = ((window.location.host).split('.') || [])[0] || ''
        this.getSchoolDetails(subdomain);
    }
    hasDuplicateString = (strings = []) => {
        const table = {};
        for (let string of strings) {
            if (string in table) return true;
            table[string] = true;
        }
        return false;
    }
    validateEmail = (mail) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        _addNotificationError("You have entered an invalid email address!", this)
        return (false)
    }
    getSchoolDetails = (domain) => {
        this.setState({ loading: true });
        get(`/schoolInfoByDomain/${domain}?includeGrade=true`, false)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                const { logoLink, schoolName, mealSchoolId, gradesMapping, schoolGrades } = data || {};
                let sgrades = [];
                Object.values(schoolGrades || {}).map(grds => {
                    sgrades = [...sgrades, ...grds];
                })
                this.setState({
                    logoUrl: logoLink,
                    schoolName: schoolName,
                    gradesMapping: (gradesMapping || []).filter(g => {
                        return sgrades.includes(g.value);
                    }),
                    schoolId: mealSchoolId,
                    loading: false
                })
            }).catch(
                (error) => {
                    _addNotificationError('Invalid URL. Please contact your school administrator.', this);
                    this.setState({ loading: false });
                    this.context.router.history.push('/404')
                    console.log('Get School data response', error)
                }
            );
    }
    getGrades = (grades) => {
        let gradeList = [];
        (grades || []).forEach(grade => {
            if (typeof grade === 'number') {
                gradeList.push({ value: converter.toWords(grade), label: grade });
            } else {
                gradeList.push({ value: grade, label: gradeTextToNumber(grade) });
            }
        });
        return gradeList;
    }
    onSubmit = (e) => {
        let headers = {
            'Content-Type': 'application/json'
        };
        let _event = { ...this.state.event };
        let parentDetails = JSON.parse(JSON.stringify(...this.state.parentDetails))
        let studentDetails = [...this.state.studentsArray]
        if ((parentDetails.emailId || '').trim() === '') {
            _addNotificationError('Please enter email Id.', this);
            return false;
        }
        if (!this.validateEmail(parentDetails.emailId)) {
            return false;
        }
        if (parentDetails.altEmailId != "") {
            if (!this.validateEmail(parentDetails.altEmailId)) {
                return false;
            }
        }
        if (parentDetails.mobile.length !== 0 && parentDetails.mobile.length < this.state.mobileMaxLength) {
            _addNotificationError('Please Provide valid mobile number.', this);
            return false;
        }

        let reqLastName = (studentDetails || []).every(rec => {
            return (rec.lastName || '').trim() != '';
        });
        let reqFirstName = (studentDetails || []).every(rec => {
            return (rec.firstName || '').trim() != '';
        });
        let reqGrade = (studentDetails || []).every(rec => {
            return (rec.grade || '').trim() != '';
        })

        if (!reqLastName) {
            _addNotificationError('Please enter Student/Staff lastName.', this);
            return false;
        }
        if (!reqFirstName) {
            _addNotificationError('Please enter Student/Staff firstName.', this);
            return false;
        }
        if (!reqGrade) {
            _addNotificationError('Please select Grade/Staff.', this);
            return false;
        }
        if (this.hasDuplicateString((studentDetails || []).map(st => `${st.lastName}-${st.firstName}-${st.grade}`))) {
            _addNotificationError('Some of duplicate students data entered. please check once again', this);
            return false;
        }

        let requestData = {
            "parent": parentDetails,
            "students": studentDetails
        }
        let schoolId = this.state.schoolId;
        fetch(BASE_URL_3 + `/studentRegistration/${schoolId}`, { method: 'post', body: JSON.stringify(requestData), headers }).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();

        }).then(data => {
            const { student } = data;
            if ((student || []).length > 0) {
                this.setState({ loading: false, respData: student || [], modalIsOpen: true });
            } else {
                this.setState({ loading: false, respData: [], modalIsOpen: true });
            }
            return false;
            //_addNotification(data.statusMessage, this);
            //this.setState({ loading: false });
            /*  setTimeout(() => {
                 window.location.reload();
             }, 1000) */

        }).catch(
            (error) => {
                _addNotificationError("Student data not saved", this);
                console.log('student data not saved', error);
                this.setState({ loading: false });
            }
        );
    }
    onChangeParentEmail = (e, index) => {
        const parentArray = this.state.parentDetails.map((parentEvent, sidx) => {
            if (index !== sidx) return parentEvent;
            return { ...parentEvent, emailId: e.target.value };
        });

        this.setState({ parentDetails: parentArray });
    };
    onChangeParentAltEmail = (e, index) => {
        const parentArray = this.state.parentDetails.map((parentEvent, sidx) => {
            if (index !== sidx) return parentEvent;
            return { ...parentEvent, altEmailId: e.target.value };
        });

        this.setState({ parentDetails: parentArray });
    };
    onChangeMobileNo = (e, index) => {
        const parentArray = this.state.parentDetails.map((parentEvent, sidx) => {
            if (index !== sidx) return parentEvent;
            return { ...parentEvent, mobile: e.target.value };
        });

        this.setState({ parentDetails: parentArray });
    };
    changeLastName = (e, index) => {
        const newStudent = this.state.studentsArray.map((student, sidx) => {
            if (index !== sidx) return student;
            return { ...student, lastName: e.target.value };
        });

        this.setState({ studentsArray: newStudent });
    };

    changeFirstName = (e, index) => {
        const newStudent = this.state.studentsArray.map((student, sidx) => {
            if (index !== sidx) return student;
            return { ...student, firstName: e.target.value };
        });

        this.setState({ studentsArray: newStudent });
    };

    changeGrade = (e, index) => {
        const newStudent = this.state.studentsArray.map((student, sidx) => {
            if (index !== sidx) return student;
            return { ...student, grade: e.target.value };
        });

        this.setState({ studentsArray: newStudent });
    };
    changestudentId = (e, index) => {
        var newStudent = this.state.studentsArray
        newStudent[index].studentId = e.target.value
        this.setState({ studentsArray: newStudent })
    }
    addNewStudent = () => {
        var newStudent = this.state.studentsArray
        newStudent.push({
            lastName: "",
            firstName: "",
            grade: "",
            studentId: ""
        })
        this.setState({ studentsArray: newStudent })
    }
    deleteStudent = (i) => {
        const updateStudent = this.state.studentsArray.filter((item, index) => index != i)
        this.setState({ studentsArray: updateStudent })
    }
    render() {
        const { event, parentEvent, gradesMapping, respData, parentDetails } = this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div>
                    <section className="mainContent full-width clearfix" style={{ padding: '0px' }}>
                        <div className='row' style={{ overflowY: 'scroll', overflowX: 'hidden', height: 'calc(100vh - 70px)' }}>
                            <div className='col-lg-5 col-md-6 col-sm-12 loginBackground'>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <div className="row">
                                    <div className='col-lg-12 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1'>
                                        <div className='row'>
                                            {
                                                (this.state.logoUrl || '').length > 0 ?
                                                    <div className='col-md-12 text-center'>
                                                        <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '10px' }}>
                                                            <img className="super-admin-logo" src={this.state.logoUrl} alt="" />
                                                        </div>
                                                    </div> : <div className='sectionTitle text-center'>
                                                        <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '10px' }}>
                                                            <h2 style={{ fontSize: '30px' }}>{this.state.schoolName}</h2>
                                                        </div>
                                                    </div>
                                            }

                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 col-xs-12 createmenu-panel">
                                                    <div className="panel panel-primary">
                                                        <div className="panel-heading">
                                                            <h3 className="panel-title"><span>Parent / Staff Details</span></h3>
                                                        </div>
                                                        {this.state.parentDetails.map((parentEvent, index) => (
                                                            <div className="row">
                                                                <div className="panel-body">
                                                                    <form className="form-horizontal">
                                                                        <div className="form-group">
                                                                            <div className="col-sm-8">
                                                                                <input type={parentEvent.emailId == 'NA' ? "text" : "email"} name="emailId" id={`Student #${index + 1} parentEmailId`}
                                                                                    className="form-control ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched" value={parentEvent.emailId}
                                                                                    pattern={parentEvent.emailId == 'NA' ? null : "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"}
                                                                                    placeholder="Enter Parent / Staff Email*" onChange={(e) => this.onChangeParentEmail(e, index)} required />
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <div className="col-sm-8">

                                                                                <input type="email" name="parentAltEmail" id={`Student #${index + 1} ParentAltEmail`}
                                                                                    pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                                    className="form-control ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched" value={parentEvent.altEmailId}
                                                                                    placeholder="Enter Parent / Staff Alternative Email" onChange={(e) => this.onChangeParentAltEmail(e, index)} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <div className="col-sm-8">
                                                                                <input type="text"
                                                                                    className="form-control"
                                                                                    value={parentEvent.mobile}
                                                                                    name="mobile"
                                                                                    id="mobile"
                                                                                    placeholder={'Enter Parent / Staff Mobile Number'}
                                                                                    onChange={(e) => this.onChangeMobileNo(e, index)}
                                                                                    maxLength={this.state.mobileMaxLength}
                                                                                    onKeyPress={numberOnly} />
                                                                            </div>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 col-xs-12 createmenu-panel">
                                                    <div className="panel panel-primary">
                                                        <div className="panel-heading">
                                                            <h3 className="panel-title"><span>Student / Staff Details</span></h3>
                                                        </div>
                                                        <div className="panel-body">
                                                            <form className="form-horizontal" >
                                                                <div className="form-group">
                                                                    {this.state.studentsArray.map((event, index) => (
                                                                        <div className="row" key={index}>
                                                                            <div className="col-sm-12" >
                                                                                <div className="col-sm-3">
                                                                                    <input type="text" id={`Student #${index + 1} Last Name`}
                                                                                        placeholder={`Last Name*`} style={styles.formInput}
                                                                                        className="form-control" value={event.lastName}
                                                                                        onChange={(e) => this.changeLastName(e, index)} required /></div>
                                                                                <div className="col-sm-3">
                                                                                    <input type="text" id={`Student #${index + 1} First Name`}
                                                                                        className="form-control" value={event.firstName} style={styles.formInput}
                                                                                        placeholder={`First Name*`} onChange={(e) => this.changeFirstName(e, index)} required /></div>

                                                                                <div className="col-sm-3">
                                                                                    <select className="form-control" id={`Student #${index + 1} Grade`} style={styles.formInput} placeholder={`Grade*`}
                                                                                        value={event.grade} onChange={(e) => this.changeGrade(e, index)} required>
                                                                                        <option value="" disabled selected>Grade / Staff*</option>
                                                                                        {
                                                                                            gradesMapping.map((grd, i) => {
                                                                                                return <option value={grd.value}>{grd.label}</option>
                                                                                            })
                                                                                        }

                                                                                    </select>
                                                                                </div>
                                                                                <div className="col-sm-2">
                                                                                    <i className="fa fa-plus" style={styles.buttonIcon} onClick={this.addNewStudent}></i> &nbsp; &nbsp;
                                                                                    {index != 0 && <i className="fa fa-trash" style={styles.buttonIcon} onClick={() => this.deleteStudent(index)}></i>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                    }
                                                                </div>
                                                                <div className="form-group">
                                                                    <div className="text-right">
                                                                        <button type="button" onClick={this.onSubmit} className="btn btn-success"
                                                                        >Register</button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div></div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.setState({ modalIsOpen: false })}
                        style={modalStyles}
                        contentLabel="Activation"
                        shouldCloseOnOverlayClick={false}
                        ariaHideApp={false}
                    >
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Students Registration Alert</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">{respData.length > 0 ?
                                <Fragment>
                                    <div className="col-md-12">
                                        <div class="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <td>Last Name</td>
                                                        <td>First Name</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        (respData || []).map(rec => {
                                                            return <tr>
                                                                <td>{rec.lastName}</td>
                                                                <td>{rec.firstName}</td>
                                                            </tr>
                                                        })
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <p style={{ textAlign: 'center' }}><span>{`The about Students/Staff already registered with this(`}<b>{((parentDetails || [])[0] || {}).emailId || ''}</b>{`) parent email.`}</span></p>
                                    </div>
                                </Fragment> :
                                <div className="col-md-12">
                                    <p style={{ textAlign: 'center', fontSize: '16px' }}>
                                        <label>Students/Staff registered successfully</label>
                                    </p>
                                </div>
                            }
                            </div>
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs pull-left" style={{ margin: '0' }}
                                onClick={() => {
                                    const url = ENV == "Development" ? `${window.location.protocol}//devapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent` : ENV == "Production" ? `${window.location.protocol}//app${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent` : `${window.location.protocol}//qaapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent`;

                                    window.open(
                                        url, '_self'
                                    );

                                }}> Go to parent dashboard</button>
                            <button type="button" className="btn btn-success btn-xs" style={{ margin: 0 }}
                                onClick={() => {
                                    this.setState({ modalIsOpen: false, loading: true, respData: [] });
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                }}> Ok
                            </button>
                        </div>
                    </Modal>
                </div ></div >)
    }
}
StudentRegistration.contextTypes = {
    router: PropTypes.object.isRequired
}
export default StudentRegistration;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/studentRegistration.jsx